import store from '@/store';
import router from '@/router';

export const ERROR_MESSAGES = {
  MISSING_ID: 'ID inválido.',
  MISSING_AUTH: 'Falta autenticación.',
  DELETE_FAILED: 'No se pudo eliminar el registro.',
};

export const getAuthData = (rootState) => {
  const { authData } = rootState.auth ?? {};
  const clinicalHistories_id = authData?.clinicalHistories_id;
  const institutions_profes_id = authData?.institutions_profes_id;
  const clinicalHistoriesHCPnum = authData?.hcpNum;

  if (!clinicalHistories_id || !institutions_profes_id) {
    throw new Error(ERROR_MESSAGES.MISSING_AUTH);
  }

  return { clinicalHistories_id, institutions_profes_id, clinicalHistoriesHCPnum };
};

export const prepareModel = (rootState, model) => {
  return {
    ...model,
    clinicalHistoriesId: rootState.auth.authData?.clinicalHistories_id,
    instProfesId: rootState.auth?.authData?.institutions_profes_id,
  };
};

export const validateId = (id, errorMessage = ERROR_MESSAGES.MISSING_ID) => {
  if (!Number.isInteger(id) || id <= 0) throw new Error(errorMessage);
};

export const handleError = (error, commit, mutation = 'SET_STATUS', fallbackValue = 'error') => {
  console.error('Error:', error?.message ?? 'Error desconocido');
  commit(mutation, fallbackValue);
};

export function getToken() {
  const route = router.currentRoute;
  const path = route?.path || '';

  const proToken = store.state.auth?.authData?.token;
  const patToken = store.state.authPat?.authData?.token;

  // Lógica por ruta
  if (path.startsWith('/paciente') || path.includes('/pat')) {
    return patToken || proToken; // fallback al proToken si el de paciente no existe
  }

  // Si está en una ruta profesional o por defecto
  return proToken || patToken; // fallback al patToken si el de profesional no existe
}

export function getPatToken() {
  return store.state.authPat.authData.token;
}

export function getInstProfesId() {
  return store.state.auth.authData.institutions_profes_id;
}

export function getPatientsId() {
  return store.state.auth.authData.patients_id;
}

export function getClinicalHistoriesId() {
  return store.state.auth.authData.clinicalHistories_id;
}

export function getPatPatientsId() {
  return store.state.authPat.authData.patientId;
}
